'use client';

import React, { createContext, useContext, type ReactNode } from 'react';

import type { SiteConfigResponse } from '@/lib/api/types/site';

type SiteBootstrapValue = {
  siteConfig: SiteConfigResponse;
  tenantId: string; // siteConfig.configuration.tenant_id
};

const SiteBootstrapContext = createContext<SiteBootstrapValue | null>(null);

type Props = {
  children: ReactNode;
  initialSiteConfig: SiteConfigResponse;
};

export function SiteBootstrapProvider({ children, initialSiteConfig }: Props) {
  const tenantId = initialSiteConfig.configuration.tenant_id;

  if (!tenantId) {
    throw new Error('SiteConfig missing configuration.tenant_id');
  }

  return (
    <SiteBootstrapContext.Provider
      value={{ siteConfig: initialSiteConfig, tenantId }}
    >
      {children}
    </SiteBootstrapContext.Provider>
  );
}

export function useSiteBootstrap(): SiteBootstrapValue {
  const ctx = useContext(SiteBootstrapContext);
  if (!ctx) {
    throw new Error(
      'useSiteBootstrap must be used within SiteBootstrapProvider',
    );
  }
  return ctx;
}
